import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let ShadowComp;

class Shadow extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: ShadowComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/base-components/shadow-comp" */
      "../../../components/javascript/base-components/shadow-comp"
    ).then(function(res) {
      ShadowComp = res.ShadowComp;
    }));

    
;
  }
}

export { Shadow };
